var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(_vm.tabList, function (item, $index) {
            return _c(
              "span",
              {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: `${item.permissson}`,
                    expression: "`${item.permissson}`",
                  },
                ],
                key: $index,
                staticClass: "tabItem",
                class: { activeName: _vm.activeName === $index },
                on: {
                  click: function ($event) {
                    return _vm.handleClick($index, item.permissson)
                  },
                },
              },
              [_vm._v(_vm._s(item.name) + " ")]
            )
          }),
          0
        ),
        _c("div", { staticClass: "opt" }, [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "div",
                {
                  staticClass: "btn flex_c_c",
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = true
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/images/order/add.png") },
                  }),
                  _vm._v(" 新增 "),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "permissson",
                      rawName: "v-permissson",
                      value: "derive",
                      expression: "'derive'",
                    },
                  ],
                  staticClass: "btn flex_c_c",
                  on: { click: _vm.derive },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/const/derive.png"),
                      alt: "导出",
                    },
                  }),
                  _vm._v(" 导出 "),
                ]
              ),
              _c(
                "BaseFilter",
                {
                  attrs: { isActive: _vm.isActive, width: 466 },
                  on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
                },
                [
                  _c(
                    "div",
                    { staticClass: "filter" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: {
                            model: _vm.filterList,
                            "label-width": "70px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "搜索" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  placeholder: "请输入代码/中文名称/简称",
                                },
                                model: {
                                  value: _vm.filterList.search,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterList, "search", $$v)
                                  },
                                  expression: "filterList.search",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.activeName === 1
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "销售员" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "320px" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择销售员",
                                      },
                                      model: {
                                        value: _vm.filterList.saleId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "saleId",
                                            $$v
                                          )
                                        },
                                        expression: "filterList.saleId",
                                      },
                                    },
                                    _vm._l(_vm.userOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.activeName === 1
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "客户" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "320px" },
                                      attrs: {
                                        filterable: "",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.filterList.companyId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "companyId",
                                            $$v
                                          )
                                        },
                                        expression: "filterList.companyId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.companyDrapdown,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.activeName === 1
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "状态" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "320px" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请选择状态",
                                      },
                                      model: {
                                        value: _vm.filterList.isActived,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "isActived",
                                            $$v
                                          )
                                        },
                                        expression: "filterList.isActived",
                                      },
                                    },
                                    _vm._l(_vm.activeOption, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: {
                    ..._vm.tableData1,
                    fileds: _vm.fileds,
                  },
                  pageIndex: _vm.pagerConfig.pageIndex,
                  pageSize: _vm.pagerConfig.pageSize,
                  loading: _vm.loading,
                  isEmptyBorder: true,
                },
                on: {
                  handlePageChange: _vm.handlePageChange,
                  sortChange: _vm.sortChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "nameCH",
                      fn: function (row) {
                        return [
                          _vm._v(" " + _vm._s(row.scope.nameCH) + " "),
                          _c("p", { staticClass: "sub" }, [
                            _vm._v(
                              " " + _vm._s(row.scope.parentCompanyNmae) + " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "isActived",
                      fn: function (row) {
                        return [
                          _c("div", {
                            staticClass: "circle",
                            style: {
                              "background-color": row.scope.isActived
                                ? " #35BA83"
                                : "#FE453D",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                row.scope.isActived ? "使用中" : "未使用"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "yy",
                      fn: function (row) {
                        return [
                          _c("img", {
                            staticClass: "license",
                            attrs: {
                              src: require("@/assets/images/system/license.png"),
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewImg(row.scope, 1)
                                },
                              },
                            },
                            [_vm._v("查看")]
                          ),
                        ]
                      },
                    },
                    {
                      key: "address",
                      fn: function (row) {
                        return [
                          _c("svg-icon", {
                            staticStyle: { "vertical-align": "-8px" },
                            attrs: { iconClass: "address", className: "icon" },
                          }),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                tabindex: 2000,
                                placement: "bottom",
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatterAddress")(
                                          `${row.scope.countryId}/${row.scope.provinceId}/${row.scope.cityId}`
                                        )
                                      ) +
                                      _vm._s(row.scope.address) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                { attrs: { type: "text", size: "mini" } },
                                [_vm._v("查看")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "remark",
                      fn: function (row) {
                        return [
                          _c("svg-icon", {
                            staticStyle: { "vertical-align": "-8px" },
                            attrs: { iconClass: "remark", className: "icon" },
                          }),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                tabindex: 2000,
                                content: row.scope.remark,
                                placement: "bottom",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { type: "text", size: "mini" } },
                                [_vm._v("查看")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.computedPermissions("修改"),
                                            expression:
                                              "computedPermissions('修改')",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        attrs: {
                                          "v-permissson":
                                            _vm.computedPermissions("修改"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateRow(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("修改")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.computedPermissions(
                                                "查看成员"
                                              ),
                                            expression:
                                              "computedPermissions('查看成员')",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        attrs: {
                                          "v-permissson":
                                            _vm.computedPermissions("查看成员"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewMember(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("查看成员")]
                                    ),
                                    !row.scope.parentCompanyId
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.computedPermissions(
                                                    "查看子公司"
                                                  ),
                                                expression:
                                                  "computedPermissions('查看子公司')",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: {
                                              "v-permissson":
                                                _vm.computedPermissions(
                                                  "查看子公司"
                                                ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.viewSub(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("查看子公司")]
                                        )
                                      : _vm._e(),
                                    !_vm.activeName && !row.scope.applyStatus
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.computedPermissions(
                                                    "审核通过"
                                                  ),
                                                expression:
                                                  "computedPermissions('审核通过')",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: {
                                              "v-permissson":
                                                _vm.computedPermissions(
                                                  "审核通过"
                                                ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateRow(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("审核通过")]
                                        )
                                      : _vm._e(),
                                    !_vm.activeName && !row.scope.applyStatus
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.computedPermissions(
                                                    "审核拒绝"
                                                  ),
                                                expression:
                                                  "computedPermissions('审核拒绝')",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: {
                                              "v-permissson":
                                                _vm.computedPermissions(
                                                  "审核拒绝"
                                                ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.refuse(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("审核拒绝")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.computedPermissions(
                                                "停用启用"
                                              ),
                                            expression:
                                              "computedPermissions('停用启用')",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        attrs: {
                                          "v-permissson":
                                            _vm.computedPermissions("停用启用"),
                                        },
                                        on: {
                                          click: () => {
                                            _vm.changeStatus(
                                              !row.scope.isActived,
                                              row.scope
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            !row.scope.isActived
                                              ? "启用"
                                              : "停用"
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("img", {
                                staticStyle: { "margin-left": "-14px" },
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1216811490
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("approved-company-dialog", {
        attrs: {
          dialogVisible: _vm.dialogFormVisible,
          editData: _vm.editData,
          userOptions: _vm.userOptions,
          callType: _vm.callType,
        },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
      _c("bill-account-dialog", {
        attrs: {
          dialogVisible: _vm.dialogFormVisible1,
          companyId: _vm.editData.id,
        },
        on: { ok: _vm.ok2, cancel: _vm.cancel2 },
      }),
      _c("RefuseReasonDialog", {
        attrs: { dialogVisible: _vm.dialogFormVisible2 },
        on: {
          ok: _vm.ok3,
          cancel: function ($event) {
            _vm.dialogFormVisible2 = false
          },
        },
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "drag", rawName: "v-drag" }],
          attrs: {
            title: "查看营业执照",
            visible: _vm.dialogVisible2,
            "append-to-body": true,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            "before-close": () => (_vm.dialogVisible2 = false),
            width: "858px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible2 = $event
            },
          },
        },
        [
          _c("div", { staticClass: "imgbox" }, [
            _c("img", { attrs: { src: _vm.certificateFileUrl } }),
          ]),
        ]
      ),
      _c("PriceSetDrawer", {
        attrs: { drawer: _vm.drawer, rowData: _vm.editData, tplType: 0 },
        on: {
          close: function ($event) {
            _vm.drawer = false
            _vm.editData = {}
          },
        },
      }),
      _c("ViewSubCompany", {
        attrs: {
          rowData: _vm.editData,
          userOptions: _vm.userOptions,
          dialogVisible: _vm.dialogVisible3,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible3 = false
            _vm.editData = {}
          },
        },
      }),
      _c("ViewMemberDialog", {
        attrs: { dialogVisible: _vm.dialogVisible4, rowData: _vm.editData },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible4 = false
            _vm.editData = {}
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }